import { Iconmark } from 'src/shared/components/icons/logos/iconmark'

type EnterpriseInvitationIconProps = {
  enterpriseLogo: string
}

const EnterpriseInvitationIcon = ({ enterpriseLogo }: EnterpriseInvitationIconProps) => {
  return (
    <div className="relative flex size-[49px] items-center justify-center rounded-[10px] border-2 border-white bg-white shadow-[0_2px_12px_rgba(27,48,41,0.1)]">
      {enterpriseLogo ? (
        <img
          src={enterpriseLogo}
          alt="enterprise logo"
          className="size-full rounded-[10px] bg-lightBorder object-cover"
        />
      ) : (
        <Iconmark className="size-full" />
      )}
    </div>
  )
}

export default EnterpriseInvitationIcon
